import styled from 'styled-components';

export const StyledFilter = styled.div`
  display: flex;
  width: 100%;
  gap: 15px;

  @media screen and (max-width: 1200px) {
    flex-wrap: wrap;
  }

  // .filter-popup {
  // display: flex;
  // gap: 20px;
  // }

  .filter-popup-header {
    text-align: center;
    padding-top: 20px;
  }

  .filter-popup-footer {
    display: flex;
    justify-content: space-evenly;
    padding-bottom: 20px;
  }

  .search-value {
    min-width: 300px;

    @media screen and (max-width: 340px) {
      flex-wrap: wrap;
      min-width: unset;
    }
  }
  .language {
    min-width: 265px;
  }
  .author {
    min-width: 160px;
  }

  .date-public {
    flex-shrink: 0;
    min-width: 160px;

    @media screen and (max-width: 400px) {
      flex-shrink: 1;
    }
  }

  .search-value,
  .language,
  .author {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .search-value-input {
  }

  .language-input {
    width: 100%;
  }
  .author-input {
    width: 100%;
  }

  .filter-popup-button {
    flex: 1;
  }
`;
